import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { getAllUsers } from 'Services';
import { setUsers } from 'Store';
import { RQ_ALL_USERS } from 'Utils';
import { getUsersHashMap } from './helper';

function useGetUsers() {
    const dispatch = useDispatch();

    return useQuery([RQ_ALL_USERS], getAllUsers, {
        onSuccess: (data) => dispatch(setUsers(getUsersHashMap(data)))
    });
}

export default useGetUsers;
